// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manual-page {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 1.25rem;
  min-height: calc(100vh - 160px);
}

.manual-sidebar {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1rem;
  position: sticky;
  top: 16px;
  max-height: calc(100vh - 180px);
  overflow: auto;
}

.manual-sidebar-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.manual-sidebar-subtitle {
  font-size: 0.8rem;
  color: var(--text-secondary);
  margin-top: 4px;
  margin-bottom: 12px;
}

.manual-nav {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.manual-nav-item {
  display: flex;
  flex-direction: column;
  text-align: left;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
  color: var(--text-primary);
  transition: border-color 0.15s;
}

.manual-nav-item:hover {
  border-color: var(--accent-l);
}

.manual-nav-item.active {
  border-color: var(--accent-l);
  background: rgba(var(--accent-rgb), 0.08);
}

.manual-nav-chapter {
  font-size: 0.73rem;
  color: var(--text-secondary);
}

.manual-nav-title {
  font-size: 0.88rem;
  margin-top: 3px;
}

.manual-content {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1.5rem;
}

.manual-header h1 {
  margin: 10px 0 6px;
  font-size: 1.5rem;
  color: var(--text-primary);
}

.manual-header p {
  color: var(--text-secondary);
  font-size: 0.88rem;
  margin-bottom: 1.25rem;
}

.manual-chapter-chip {
  display: inline-block;
  border: 1px solid rgba(var(--accent-rgb), 0.4);
  color: var(--accent-l);
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 0.73rem;
}

.manual-section p {
  line-height: 1.65;
  color: var(--text-primary);
  margin-bottom: 0.75rem;
}

.manual-checklist {
  margin: 0.75rem 0 1rem;
  padding-left: 1.2rem;
}

.manual-checklist li {
  margin-bottom: 6px;
  color: var(--text-primary);
  line-height: 1.55;
}

.manual-code-wrap {
  border: 1px solid var(--border);
  border-radius: 10px;
  margin-top: 1rem;
  overflow: hidden;
}

.manual-code-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 10px;
  background: var(--bg-toolbar);
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.manual-copy-btn {
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 3px 9px;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  font-size: 0.75rem;
}

.manual-copy-btn:hover {
  color: var(--text-primary);
  border-color: var(--accent-l);
}

.manual-code-block {
  margin: 0;
  padding: 10px 12px;
  font-size: 0.8rem;
  overflow: auto;
  background: var(--bg-app, #0a0f1a);
  color: var(--text-primary);
}

@media (max-width: 1024px) {
  .manual-page {
    grid-template-columns: 1fr;
  }

  .manual-sidebar {
    position: static;
    max-height: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ManualCMDB.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":[".manual-page {\r\n  display: grid;\r\n  grid-template-columns: 300px 1fr;\r\n  gap: 1.25rem;\r\n  min-height: calc(100vh - 160px);\r\n}\r\n\r\n.manual-sidebar {\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 1rem;\r\n  position: sticky;\r\n  top: 16px;\r\n  max-height: calc(100vh - 180px);\r\n  overflow: auto;\r\n}\r\n\r\n.manual-sidebar-title {\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.manual-sidebar-subtitle {\r\n  font-size: 0.8rem;\r\n  color: var(--text-secondary);\r\n  margin-top: 4px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.manual-nav {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.manual-nav-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  text-align: left;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  border-radius: 10px;\r\n  padding: 10px;\r\n  cursor: pointer;\r\n  color: var(--text-primary);\r\n  transition: border-color 0.15s;\r\n}\r\n\r\n.manual-nav-item:hover {\r\n  border-color: var(--accent-l);\r\n}\r\n\r\n.manual-nav-item.active {\r\n  border-color: var(--accent-l);\r\n  background: rgba(var(--accent-rgb), 0.08);\r\n}\r\n\r\n.manual-nav-chapter {\r\n  font-size: 0.73rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.manual-nav-title {\r\n  font-size: 0.88rem;\r\n  margin-top: 3px;\r\n}\r\n\r\n.manual-content {\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n}\r\n\r\n.manual-header h1 {\r\n  margin: 10px 0 6px;\r\n  font-size: 1.5rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.manual-header p {\r\n  color: var(--text-secondary);\r\n  font-size: 0.88rem;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.manual-chapter-chip {\r\n  display: inline-block;\r\n  border: 1px solid rgba(var(--accent-rgb), 0.4);\r\n  color: var(--accent-l);\r\n  border-radius: 999px;\r\n  padding: 3px 10px;\r\n  font-size: 0.73rem;\r\n}\r\n\r\n.manual-section p {\r\n  line-height: 1.65;\r\n  color: var(--text-primary);\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.manual-checklist {\r\n  margin: 0.75rem 0 1rem;\r\n  padding-left: 1.2rem;\r\n}\r\n\r\n.manual-checklist li {\r\n  margin-bottom: 6px;\r\n  color: var(--text-primary);\r\n  line-height: 1.55;\r\n}\r\n\r\n.manual-code-wrap {\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  margin-top: 1rem;\r\n  overflow: hidden;\r\n}\r\n\r\n.manual-code-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 7px 10px;\r\n  background: var(--bg-toolbar);\r\n  font-size: 0.8rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.manual-copy-btn {\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  padding: 3px 9px;\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.manual-copy-btn:hover {\r\n  color: var(--text-primary);\r\n  border-color: var(--accent-l);\r\n}\r\n\r\n.manual-code-block {\r\n  margin: 0;\r\n  padding: 10px 12px;\r\n  font-size: 0.8rem;\r\n  overflow: auto;\r\n  background: var(--bg-app, #0a0f1a);\r\n  color: var(--text-primary);\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .manual-page {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .manual-sidebar {\r\n    position: static;\r\n    max-height: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
